import React from 'react';
import { Typography } from '@mui/material';

export const GameTags = ({ gameTags, studio }) => {
    if (!gameTags || gameTags.length === 0) return null;

    return (
        <div className="details-group">
            <Typography variant="h6" className="section-title">Game Tags</Typography>
            <div className="details-grid">
                <Typography variant="body1">Studio: {studio?.title || 'N/A'}</Typography>
                {gameTags.map((tag, index) => (
                    <Typography key={index} variant="body1">{tag.label}: {tag.value}</Typography>
                ))}
            </div>
        </div>
    );
};